/** @format */

import React, { useEffect, useState } from 'react';
import '../../css/modals/QuestionHeader.css';

import { IoClose } from 'react-icons/io5';

import { useSelector, useDispatch } from 'react-redux';

import { closeQuestion } from '../../features/question';

const QuestionHeader = () => {
  const [visibility, setVisibility] = useState('hidden');
  const [container, setContainer] = useState('question-header-closed');

  const modal = useSelector((state) => state.question.value.modal);

  const dispatch = useDispatch();

  useEffect(() => {
    if (modal) {
      setVisibility('visible');
      setTimeout(() => {
        setContainer('');
      }, 100);
    }
  }, [modal]);

  const handleCloseModal = (event) => {
    if (event.target.className === 'QuestionHeader') {
      setContainer('question-header-closed');
      setTimeout(() => {
        // handleOpenModal(false);
        dispatch(closeQuestion());
        setVisibility('hidden');
      }, 100);
    }
  };

  return (
    <div
      className='QuestionHeader'
      style={{ visibility: `${visibility}` }}
      onClick={handleCloseModal}>
      <div className={`question-header-container ${container}`}>
        <button
          className='question-header-closer'
          onClick={() => {
            setContainer('question-header-closed');
            setTimeout(() => {
              // handleOpenModal(false);
              dispatch(closeQuestion());
              setVisibility('hidden');
            }, 100);
          }}>
          <IoClose />
        </button>
        <p>
          Nuestro entrenamiento online en vivo dura un mes, pero
          podrás tener acceso a las clases grabadas por un año.
        </p>
        <br />
        <p style={{ color: '#6000de', fontWeight: '500' }}>
          ¿Más dudas?&nbsp;
          <span>
            <a
              href='https://api.whatsapp.com/send?phone=573219325781&text=Hola%20Libel%2C%20tengo%20la%20siguiente%20pregunta%20%F0%9F%96%90%EF%B8%8F'
              target={'_blank'}
              rel='noreferrer'
              style={{ color: '#6000de' }}>
              Escríbenos a Whatsapp
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};

export default QuestionHeader;
